import React, { Component } from "react";
import services from "../../services";

let combolistrequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: false,
    Page: 2,
    PageSize: 2,
};

class LocationSelection extends Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            flag: 1,
            busentdistrito: [],
            busentconcelho: [],
            BusEntFreguesia: [],
            form: {
                distrito_id: "0",
                country_id: "0",
                fregusia_id: "0",
            },
            error: null,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */
    componentDidMount = () => {
        console.log("800 mount", this.state.form);
        if (this.state.flag != 1) {
            let flag = 1;
            this.setState({
                flag,
            });
        }
        console.log("props in location", this.props);
        this.getDistricList();
        this.createState();
    };

    componentDidUpdate(preProp) {
        console.log("800 uppdate", this.state.form);
        if (preProp.date !== this.props.date) {
            this.createState();
            console.log("location update worked 6677");
            if (this.state.flag == 2 || this.state.flag == 1) {
                this.createState();
                this.state.flag++;
            } else if (this.props.module !== "Vinica") {
                this.createState();
            }
            console.log(
                "66655 state ",
                this.state.form,
                "flag",
                this.state.flag
            );
        }
    }

    createState = () => {
        console.log("800 crrate state", this.state.form);
        let form = { ...this.state.form };
        if (form.distrito_id != this.props.distrito_id) {
            form.distrito_id = this.props.distrito_id;
            this.getcodconList(form.distrito_id);
        }

        if (form.country_id != this.props.country_id) {
            form.country_id = this.props.country_id;
            this.getcodfrglist(form.country_id);
        }

        if (form.fregusia_id != this.props.fregusia_id) {
            form.fregusia_id = this.props.fregusia_id;
        }
        this.setState({ form });
    };

    getDistricList = async () => {
        console.log("800 get district", this.state.form);
        let busentdistrito = await services.apiCall.requestApi(
            "/busentdistrito/GetAll/",
            combolistrequest,
            "post"
        );
        if (busentdistrito) {
            this.setState({
                busentdistrito,
            });
        }
    };

    getcodconList = async (id) => {
        console.log("800 cod llist", this.state.form);
        if (parseInt(id) > 0) {
            let busentconcelho = await services.apiCall.requestApi(
                "/busentconcelho/getbyid/" + id,
                {},
                "post"
            );
            if (busentconcelho) {
                let obj = { busentconcelho };
                if (this.props.module === "Vinica") {
                    console.log("800 cod llist inside", this.state.form);
                    let { form, BusEntFreguesia } = this.state;
                    form["country_id"] = "";
                    form["fregusia_id"] = "";
                    obj = {
                        ...obj,
                        // form,
                        BusEntFreguesia: [],
                    };
                }
                this.setState(
                    (preState) => ({
                        ...preState,
                        ...obj,
                    }),
                    () => {
                        console.log("7788 form , ", this.state.form);
                    }
                );
            }
        }
    };

    getcodfrglist = async (id) => {
        console.log("800 frg cod", this.state.form);
        if (parseInt(id) > 0) {
            let reqData = {
                districtId:
                    +this.state.form.distrito_id || this.props.distrito_id,
                countryId: +id,
            };
            console.log("9990 reqData ", reqData);
            let BusEntFreguesia = await services.apiCall.requestApi(
                "/BusEntFreguesia/GetByID",
                reqData,
                "post"
            );
            if (BusEntFreguesia) {
                this.setState({
                    BusEntFreguesia,
                });
            }
        }
    };

    handleChange = (e) => {
        console.log("800 onchnage", this.state.form);
        try {
            const { form } = this.state;
            let key = e.target.name;
            let value = e.target.value;
            form[key] = value;
            if (key === "distrito_id") {
                this.getcodconList(value);
            } else if (key === "country_id") {
                this.getcodfrglist(value);
            }
            this.setState(
                {
                    form,
                },
                () => {
                    if (this.props.locationFor === "Localização") {
                        let {
                            busentconcelho,
                            busentdistrito,
                            BusEntFreguesia,
                        } = this.state;
                        let listObj = {
                            distrito_id: busentdistrito,
                            country_id: busentconcelho,
                            fregusia_id: BusEntFreguesia,
                        };
                        this.props.getLocationData(key, value, listObj);
                    } else {
                        console.log("2009 getLocationData worked ", key, value);
                        this.props.getLocationData(key, value);
                    }
                }
            );
        } catch (error) {
            this.setState({ error });
        }
    };

    /*  Para renderizar o conteúdo html da página   */
    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        return (
            <React.Fragment>
                {/*<div className="col-md-12">
        <div className="row mt-3">*/}
                <div
                    className={
                        this.props.module === "Vinica" ? "col-md-4" : "col-md-4"
                    }
                >
                    <div className="input-box active-grey drop-down-box">
                        <label className="input-label">Distrito </label>
                        <select
                            className="custome-drop-down"
                            onChange={(e) => this.handleChange(e)}
                            name="distrito_id"
                            value={this.state.form.distrito_id || ""}
                        >
                            <option value="">Selecione Distrito </option>
                            {this.state.busentdistrito &&
                                this.state.busentdistrito.map((_row, index) => (
                                    <option value={_row.coddis} key={index}>
                                        {_row.desdis}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
                <div
                    className={
                        this.props.module === "Vinica" ? "col-md-4" : "col-md-4"
                    }
                >
                    <div className="input-box active-grey drop-down-box">
                        <label className="input-label">Concelho</label>
                        <select
                            className="custome-drop-down"
                            onChange={(e) => this.handleChange(e)}
                            name="country_id"
                            value={this.state.form.country_id}
                        >
                            <option value="">Selecione Concelho</option>
                            {this.state.busentconcelho &&
                                this.state.busentconcelho.map((_row, index) => (
                                    <option value={_row.codcon} key={index}>
                                        {_row.descon}
                                    </option>
                                ))}
                        </select>
                    </div>
                </div>
                <div
                    className={
                        this.props.module === "Vinica" ? "col-md-4" : "col-md-4"
                    }
                >
                    <div className="input-box active-grey drop-down-box">
                        <label className="input-label">Freguesia </label>
                        <select
                            className="custome-drop-down"
                            onChange={(e) => this.handleChange(e)}
                            name="fregusia_id"
                            value={this.state.form.fregusia_id}
                        >
                            <option value="">Selecione Freguesia </option>
                            {this.state.BusEntFreguesia &&
                                this.state.BusEntFreguesia.map(
                                    (_row, index) => (
                                        <option value={_row.codfrg} key={index}>
                                            {_row.desfrg}
                                        </option>
                                    )
                                )}
                        </select>
                    </div>
                </div>

                {/*</div>
            </div>*/}
            </React.Fragment>
        );
    }
}

export default LocationSelection;
